var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"group-section-wrapper"},[_c('label',{staticClass:"title"},[_vm._v(_vm._s(_vm.getTitle))]),_vm._v(" "),_c('div',{staticClass:"indicator-wrapper",on:{"click":_vm.onclick}},[(_vm.isShowIndicator)?_c('img',{staticClass:"indicator",attrs:{"src":require("../../../assets/image/change-icon/enter@2x.png")}}):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1c528d50","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/cardpage/group/GroupSection.vue
// module id = null
// module chunks = 